export enum DocumentTypeEnum {
  DNI = 1,
  CUIL = 2,
  CUIT = 3,
  CFINAL = 99,
}
